var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"orange white--text",attrs:{"small":""},on:{"click":_vm.start}},[_vm._v(" "+_vm._s(_vm._f("t")('action.reset-password'))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }